export const create = {
  form: {
    name: 'Name',
    typeName: 'Type name',
    washingInfo: 'Washing info',
    tankInfo: 'Tank info',
    tankNo: 'Tank no',
    submit: 'Submit',
    select: 'Select',
    requireName: 'Please input machine name',
    requireTypeName: 'Please input machine type name',
  },
  pageHeader: {
    title: 'New Machine',
    back: 'Back',
  },
}
